import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=725c6420&"
import script from "./rich-editor.vue?vue&type=script&lang=js&"
export * from "./rich-editor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports